// validationHelpers.js
export const isPastDate = (value) => {
    if (!value) return true;
    const date = new Date(value);
    const now = new Date();
    return date <= now;
  };
  
  export const isFutureDate = (value) => {
    if (!value) return true;
    const date = new Date(value);
    const now = new Date();
    return date > now;
  };
  
  export const isAtLeast18 = (value) => {
    if (!value) return true;
    const dob = new Date(value);
    const now = new Date();
    const age = now.getFullYear() - dob.getFullYear();
    const monthDiff = now.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < dob.getDate())) {
      return age - 1 >= 18;
    }
    return age >= 18;
  };